import { useTranslation } from 'react-i18next';
import { withForm } from '../../components/form/hooks';
import { loginFormOptions } from './loginFormOptions';
import { FieldBase } from '../../components/form/fieldComponents/fieldBase';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui/v2';
import {
  lohnabrechnungsart,
  type Lohnabrechnungsart,
} from './constants/lohnabrechnungsart';

export const LoginInputs = withForm({
  ...loginFormOptions,
  render: function Render({ form }) {
    const { t } = useTranslation();
    return (
      <div className="flex flex-col gap-4">
        <form.AppField name="beraternummer">
          {(field) => (
            <field.TextInput
              label={t('domain.datev.login.form.beraternummer.label')}
            />
          )}
        </form.AppField>
        <form.AppField name="mandantennummer">
          {(field) => (
            <field.TextInput
              label={t('domain.datev.login.form.mandantennummer.label')}
            />
          )}
        </form.AppField>
        <form.AppField name="lohnabrechnungsart">
          {(field) => (
            <FieldBase label={t('domain.datev.login.form.lohnsystem.label')}>
              <Select
                value={field.state.value}
                onValueChange={(val) =>
                  field.handleChange(val as Lohnabrechnungsart)
                }>
                <SelectTrigger>
                  <SelectValue placeholder={t('combobox.placeholder')} />
                </SelectTrigger>
                <SelectContent>
                  {Object.values(lohnabrechnungsart).map((l) => (
                    <SelectItem key={l} value={l}>
                      {t('domain.datev.login.form.lohnsystem.options.' + l)}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FieldBase>
          )}
        </form.AppField>
      </div>
    );
  },
});
